import React, { Fragment, useEffect, useState } from 'react'
import { GoTop } from './go-top';
import { FiFacebook, FiInstagram, FiTwitter, FiYoutube } from "react-icons/fi";
import { Link } from 'react-router-dom';
import { handleError } from 'config/libraries';
export const Footer = () => {
	const [DataResponse, setDataResponse] = useState(null);

	useEffect(() => {
		const axios = require('axios');
        axios.get(process.env.REACT_APP_SERVER_BASE_URL + '/konfigurasi-website').then(function (response) {
            setDataResponse(response.data.data[0]);
        }).catch(function (error) {
            handleError(error)
        })
        return () => {
            setDataResponse(null);
        };
	}, []);
    return (
        <>
			{(DataResponse != null) ? 
			<Fragment>
				<footer id="footer-container" className="jl_footer_act enable_footer_columns_dark">
				<div className="footer-columns">
				<div className="container">
					<div className="row">
					<div className="col-md-4">
						<div id="sprasa_about_us_widget-2" className="widget jellywp_about_us_widget">
						<div className="widget_jl_wrapper about_widget_content">
							<div className="jellywp_about_us_widget_wrapper">
								<img className="footer_logo_about" src={process.env.REACT_APP_SERVER_IMAGE_URL + DataResponse.logo_website} alt="" />
								<p>{DataResponse.motto}</p>
							</div>
						</div>
						</div>
						<div id="sprasa_about_us_widget-4" className="widget jellywp_about_us_widget">
						<div className="widget_jl_wrapper about_widget_content">
							<div className="jellywp_about_us_widget_wrapper">
							<div className="social_icons_widget">
								<ul className="social-icons-list-widget icons_about_widget_display">
								<li>
									<a href={DataResponse.facebook} rel="noopener noreferrer" className="facebook" target="_blank"><FiFacebook /></a>
								</li>
								<li>
									<a href={DataResponse.instagram} rel="noopener noreferrer" className="instagram" target="_blank"><FiInstagram /></a>
								</li>
								<li>
									<a href={DataResponse.youtube} rel="noopener noreferrer" className="youtube" target="_blank"><FiYoutube /></a>
								</li>
								<li>
									<a href={DataResponse.twitter} rel="noopener noreferrer" className="twitter" target="_blank"><FiTwitter /></a>
								</li>
								</ul>
							</div>
							</div>
						</div>
						</div>
					</div>
					<div className="col-md-4">
						<div id="sprasa_recent_post_text_widget-8" className="widget post_list_widget">
						<div className="widget_jl_wrapper">
							<div className="ettitle">
							<div className="widget-title"><h2 className="jl_title_c">Kontak</h2></div>
							</div>
							<div className="bt_post_widget">
							<div className="jl_m_right jl_sm_list jl_ml jl_clear_at">
								<div className="jl_m_right_w">
									<div className="">
										<h2 className="entry-title mb-2 text-white">Alamat</h2>
										<p className='mb-0'>{DataResponse.alamat}</p>
									</div>
								</div>
							</div>
							<div className="jl_m_right jl_sm_list jl_ml jl_clear_at">
								<div className="jl_m_right_w">
									<div className="">
										<h2 className="entry-title mb-2 text-white">Email</h2>
										<p className='mb-0'>{DataResponse.email}</p>
									</div>
								</div>
							</div>
							<div className="jl_m_right jl_sm_list jl_ml jl_clear_at">
								<div className="jl_m_right_w">
									<div className="">
										<h2 className="entry-title mb-2 text-white">No Telepon</h2>
										<p className='mb-0'>{DataResponse.no_telepon}</p>
									</div>
								</div>
							</div>
							</div>
						</div>
						</div>
					</div>
					<div className="col-md-4">
						<div className="widget_jl_wrapper jl_clear_at">
						<div id="sprasa_category_image_widget_register-2" className="widget jellywp_cat_image">
							<div className="widget-title"><h2 className="jl_title_c">Lokasi</h2></div>
							<div className="wrapper_category_image">
								<div className="category_image_wrapper_main" >
									<div dangerouslySetInnerHTML={{ __html: DataResponse.google_maps }}></div>
								</div>
							</div>
						</div>
						</div>
					</div>
					</div>
				</div>
				</div>
				<div className="footer-bottom enable_footer_copyright_dark">
				<div className="container">
					<div className="row bottom_footer_menu_text">
					<div className="col-md-12">
						<div className="jl_ft_w">
						© Copyright { new Date().getFullYear() } Dinas Pendidikan. All rights reserved powered by <a className='text-footer-microdata' rel='noreferrer' target="_blank" href="http://microdataindonesia.co.id/">PT Microdata Indonesia</a>
						<ul id="menu-footer-menu" className="menu-footer">
							<li className="menu-item menu-item-6"><Link title="#!" to={'/infografis'}>Infografis</Link></li>
							<li className="menu-item menu-item-7"><Link title="#!" to={'/download'}>Download</Link></li>
							<li className="menu-item menu-item-8"><Link title="#!" to={'/informasi/layanan'}>Pelayanan</Link></li>
							<li className="menu-item menu-item-9"><Link title="#!" to={'/kritik-dan-saran'}>Kritik dan Saran</Link></li>
						</ul>
						</div>
					</div>
					</div>
				</div>
				</div>
				</footer>
				{/* <GoTop/> */}
			</Fragment> : ''}
		</>
    )
};